import * as React from "react";
import { SVGProps } from "react";

interface StarProps extends SVGProps<SVGSVGElement> {
  fill?: string; // New fill prop
}

const Star = ({ fill = "white", ...props }: StarProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Vuesax outline star">
      <g id="Star">
        <path
          id="Vector"
          d="M9.4802 20.6901C8.9802 20.6901 8.6302 20.5201 8.4202 20.3601C8.0202 20.0701 7.40019 19.3201 7.79019 17.6401L8.36017 15.1801C8.41017 14.9701 8.30018 14.5901 8.15018 14.4301L6.16019 12.4401C5.11019 11.3901 5.20018 10.4801 5.34018 10.0301C5.48018 9.58006 5.94018 8.79005 7.40018 8.54005L9.9502 8.12006C10.1402 8.09006 10.4502 7.86006 10.5302 7.69006L11.9402 4.87006C12.6202 3.51006 13.5202 3.31006 14.0002 3.31006C14.4802 3.31006 15.3802 3.51006 16.0602 4.87006L17.4702 7.69006C17.5602 7.86006 17.8602 8.09006 18.0502 8.12006L20.6002 8.54005C22.0602 8.78005 22.5202 9.58006 22.6602 10.0301C22.8002 10.4801 22.8902 11.3901 21.8402 12.4401L19.8502 14.4301C19.7002 14.5801 19.5902 14.9701 19.6402 15.1801L20.2102 17.6401C20.6002 19.3301 19.9802 20.0701 19.5802 20.3601C19.1802 20.6501 18.2902 21.0201 16.7902 20.1301L14.4002 18.7101C14.2002 18.5901 13.7802 18.5901 13.5802 18.7101L11.1902 20.1301C10.5002 20.5501 9.9202 20.6901 9.4802 20.6901ZM14.0002 4.81006C13.8402 4.81006 13.5502 5.00005 13.2802 5.54005L11.8702 8.36006C11.5702 8.97006 10.8602 9.49007 10.1902 9.60007L7.6402 10.0201C7.0702 10.1201 6.8102 10.3301 6.7602 10.4901C6.7102 10.6501 6.80018 10.9701 7.21018 11.3801L9.2002 13.3701C9.7102 13.8801 9.98019 14.8101 9.82019 15.5101L9.25019 17.9701C9.08019 18.6801 9.19017 19.0601 9.30017 19.1501C9.41017 19.2301 9.81018 19.2201 10.4302 18.8401L12.8302 17.4201C13.5002 17.0201 14.5102 17.0201 15.1702 17.4201L17.5602 18.8401C18.1902 19.2101 18.5902 19.2301 18.7002 19.1501C18.8102 19.0701 18.9202 18.6901 18.7502 17.9701L18.1802 15.5101C18.0202 14.8001 18.2802 13.8801 18.8002 13.3701L20.7902 11.3801C21.2002 10.9701 21.2902 10.6401 21.2402 10.4901C21.1902 10.3401 20.9302 10.1201 20.3602 10.0201L17.8102 9.60007C17.1402 9.49007 16.4302 8.97006 16.1302 8.36006L14.7202 5.54005C14.4502 5.00005 14.1602 4.81006 14.0002 4.81006Z"
          fill={fill || "white"}
        />
        <path
          id="Vector_2"
          d="M8 5.75H2C1.59 5.75 1.25 5.41 1.25 5C1.25 4.59 1.59 4.25 2 4.25H8C8.41 4.25 8.75 4.59 8.75 5C8.75 5.41 8.41 5.75 8 5.75Z"
          fill={fill || "white"}
        />
        <path
          id="Vector_3"
          d="M5 19.75H2C1.59 19.75 1.25 19.41 1.25 19C1.25 18.59 1.59 18.25 2 18.25H5C5.41 18.25 5.75 18.59 5.75 19C5.75 19.41 5.41 19.75 5 19.75Z"
          fill={fill || "white"}
        />
        <path
          id="Vector_4"
          d="M3 12.75H2C1.59 12.75 1.25 12.41 1.25 12C1.25 11.59 1.59 11.25 2 11.25H3C3.41 11.25 3.75 11.59 3.75 12C3.75 12.41 3.41 12.75 3 12.75Z"
          fill={fill || "white"}
        />
      </g>
    </g>
  </svg>
);

export default Star;
